import { FEATURE_NUVEM_MARKETING } from 'App/features';
import { MARKETING_AUTOMATION_ENABLED } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useRoles } from 'domains/Auth/authSlice/useRoles';
import { useStatusFeatureByKey } from 'domains/Auth/hooks';
import { useNuvemApps } from 'domains/PartnersApps/pages/NuvemAppPage/hooks';
import { useHasNuvemMarketingAccessQuery } from 'domains/PartnersApps/partnersAppsApi';

export function useNuvemMarketing() {
  const { nuvemApps } = useNuvemApps();
  const hasNuvemMarketingApplication = !!nuvemApps['marketing-automation'];

  const { validateRoles } = useRoles();
  const hasNuvemMarketingRole = validateRoles('nuvem_marketing');

  const {
    data: hasAccessFromEndpoint,
    isLoading,
    isError,
  } = useHasNuvemMarketingAccessQuery();

  const { isAvailable: hasNuvemMarketingFeature } = useStatusFeatureByKey(
    FEATURE_NUVEM_MARKETING,
  );

  const [hasNuvemMarketingTag] = useHasTags([MARKETING_AUTOMATION_ENABLED]);

  const hasAccessToNuvemMarketing =
    isLoading || isError ? false : hasAccessFromEndpoint ?? false;

  return {
    hasNuvemMarketingTag,
    hasNuvemMarketingFeature,
    hasNuvemMarketingApplication,
    hasNuvemMarketingRole,
    hasAccessToNuvemMarketing,
  };
}
